import React from "react";
import { Colors } from "../../../utils/colors";
import { formatDate } from "../../../utils/utils";

type props = {
  bookingDate: string;
};

export const MatchBookingDate: React.FC<props> = ({ bookingDate }) => {
  return (
    <span
      style={{
        color: Colors.grey,
        fontWeight: 500,
        fontSize: 14,
        textAlign: "center",
      }}>
      {formatDate(bookingDate)}
    </span>
  );
};
